import { NgModule } from '@angular/core';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { UserModule } from '../user/user.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LayoutModule } from '../layouts/layout.module';
import { WorksheetListComponent } from './components/worksheet-list/worksheet-list.component';
import { WorksheetItemComponent } from './components/worksheet-item/worksheet-item.component';
import { VideoGalleryComponent } from './components/video-gallery/video-gallery.component';
import { BenefitsWorksheetListComponent } from './components/benefits-worksheet-list/benefits-worksheet-list.component';
import { BenefitsWorksheetItemComponent } from './components/benefits-worksheet-item/benefits-worksheet-item.component';
import { SubscriptionsListComponent } from './components/subscriptions-list/subscriptions-list.component';
import { MembershipDetailsComponent } from './components/membership-details/membership-details.component';
import { UpgradeBannerComponent } from './components/upgrade-banner/upgrade-banner.component';
import { MembershipBenefitsComponent } from './components/membership-benefits/membership-benefits.component';
import { MvpMembershipBannerComponent } from './components/mvp-membership-banner/mvp-membership-banner.component';
import { CartItemSubscriptionsComponent } from './components/cart-item-subscriptions/cart-item-subscriptions.component';
import { ClubModule } from '../club/club.module';

@NgModule({
  declarations: [
    WorksheetListComponent,
    WorksheetItemComponent,
    VideoGalleryComponent,
    BenefitsWorksheetListComponent,
    BenefitsWorksheetItemComponent,
    SubscriptionsListComponent,
    MembershipDetailsComponent,
    UpgradeBannerComponent,
    MembershipBenefitsComponent,
    MvpMembershipBannerComponent,
    CartItemSubscriptionsComponent,
  ],
  exports: [
    WorksheetListComponent,
    WorksheetItemComponent,
    VideoGalleryComponent,
    BenefitsWorksheetListComponent,
    SubscriptionsListComponent,
    MembershipDetailsComponent,
    UpgradeBannerComponent,
    MembershipBenefitsComponent,
    MvpMembershipBannerComponent,
    CartItemSubscriptionsComponent,
  ],
  imports: [
    ClubModule,
    RouterModule,
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
    BrowserAnimationsModule,
    SharedModule,
    InlineSVGModule.forRoot(),
    UserModule,
    LayoutModule,
    FGBSharedModule
  ],
})
export class LoyaltyModule {}
